import { Box, Typography, useTheme } from "@mui/material";
import welcomeBg from "../../assets/welcomeBg/welcomeBackground.svg";

const WelcomePage = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: "85vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "75%",
          height: "75%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "relative",
          backgroundImage: `url(${welcomeBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 3,
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
          }}
        >
          <Typography
            color={theme.palette.text.primary}
            variant="h4"
            fontWeight={600}
            sx={{
              textShadow:
                theme.palette.mode === "dark"
                  ? "0 2px 8px rgba(0,0,0,0.35), 0 0 2px #fff"
                  : null,
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
                md: "2rem",
              },
              textAlign: "center",
              maxWidth: {
                xs: "70vw",
                sm: "80vw",
                md: 500,
              },
            }}
          >
            Não há páginas criadas
          </Typography>
          <Typography
            variant="h6"
            color={theme.palette.text.primary}
            align="center"
            sx={{
              mb: 1,
              maxWidth: {
                xs: "50vw",
                sm: "60vw",
                md: "40vw",
                lg: 500,
              },
              textShadow:
                theme.palette.mode === "dark"
                  ? "0 2px 8px rgba(0,0,0,0.7), 0 0 1px #fff"
                  : null,
              fontSize: {
                xs: "0.8rem",
                sm: "1rem",
                md: "1.25rem",
              },
              textAlign: "center",
            }}
          >
            Você ainda não possui páginas criadas para visualizar
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default WelcomePage;
